module.exports = __webpack_public_path__ + "img/ETH.ed79179a.svg";